import { AbsenceCategoryEnum } from '@wilson/absences';
import { RoleIDsMap } from '@wilson/interfaces';

export const VACATION_CATEGORIES_IDS = [
  AbsenceCategoryEnum.Vacation,
  AbsenceCategoryEnum.EducationVacation,
  AbsenceCategoryEnum.SpecialVacation,
  AbsenceCategoryEnum.UnpaidVacation,
];

export const VACATION_CATEGORIES_IDS_OVERTIME_REDUCTION = [
  ...VACATION_CATEGORIES_IDS,
  AbsenceCategoryEnum.ReducedOverHours,
];

export const FORBID_EDITING_ABSENCE_CATEGORIES_IDS = [
  AbsenceCategoryEnum.Vacation,
  AbsenceCategoryEnum.EducationVacation,
  AbsenceCategoryEnum.SpecialVacation,
  AbsenceCategoryEnum.UnpaidVacation,
  AbsenceCategoryEnum.SickLeave,
];

// Duplicated in the backend, keep both lists in sync:
// https://gitlab.com/menlo79/wilson-backend/-/blob/main/libs/absences/services/src/absence-decisions.service.ts#L19-25
export const HR_APPROVER_ROLE_IDS: string[] = [
  RoleIDsMap.DispatcherOperations,
  RoleIDsMap.OperativeStaffWorkingTimeManager,
  RoleIDsMap.DispatcherPersonnel,
  RoleIDsMap.HumanResources,
  RoleIDsMap.CompanyAdmin,
];
